import { TDeviceType } from '@cian/ui-kit';

import { EPlatform } from '../types/platform';

export function getPlatformByDeviceType(device: TDeviceType): EPlatform {
  return device === 'desktop' ? EPlatform.Desktop : EPlatform.Mobweb;
}
